import { Box, FlexBox, Text } from '@trmediaab/zebra';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectPremium } from '~/containers/Auth/selectors';
import { getInterviewText } from '~/containers/RoundTip/Interviews/utils';
import RoundText from '~/containers/RoundTip/RoundText';
import Start from '~/containers/Start';
import StartStatistics from '~/containers/StartStatistics';

import AccessControl from './AccessControl';
import BoxedContent from './BoxedContent';
import PreviousStarts from './PreviousStarts';
import Driver from './Stats/Driver';
import Horse from './Stats/Horse';
import Trainer from './Stats/Trainer';

const Expanded = ({ start, betType }) => (
  <FlexBox
    gap="2"
    pt="2"
    pb="4"
    bg="background.secondary"
    flexDirection={{
      xs: 'column',
      lg: 'row',
    }}
  >
    <Box
      flex={{
        xs: undefined,
        lg: '1',
      }}
    >
      <AccessControl>
        <Start
          id={start.id}
          render={start => (
            <FlexBox
              flexDirection="column"
              gap="1"
              minWidth={{ xs: undefined, lg: '50%' }}
            >
              {start.interviews && start.interviews.length > 0 && (
                <BoxedContent
                  title={
                    start.interviews.length > 1 ? 'INTERVJUER' : 'INTERVJU'
                  }
                >
                  {start.interviews.map(int => (
                    <RoundText
                      key={int.id}
                      text={getInterviewText(int.text, int.byline)}
                    />
                  ))}
                </BoxedContent>
              )}

              {start.comments.length > 0 && (
                <BoxedContent title="TIPSKOMMENTAR">
                  {start.comments.map((comment, i) => (
                    <RoundText key={i} text={comment.text} />
                  ))}
                </BoxedContent>
              )}

              <BoxedContent title="TIDIGARE STARTER">
                {start.previous_starts.length > 0 ? (
                  <PreviousStarts starts={start.previous_starts} />
                ) : (
                  <Text color="text.tertiary">
                    Loppkommentarer endast tillgängligt för svenska starter.
                  </Text>
                )}
              </BoxedContent>
            </FlexBox>
          )}
        />
      </AccessControl>
    </Box>

    <Box
      flex={{
        xs: undefined,
        lg: '0.7',
      }}
    >
      <StartStatistics
        id={start.id}
        render={stats => (
          <FlexBox flexDirection="column" gap="1">
            <BoxedContent title="HÄST">
              {stats.horse && stats.horse.all ? (
                <Horse stats={stats.horse} start={start} betType={betType} />
              ) : (
                <Text color="text.tertiary">Statistik saknas</Text>
              )}
            </BoxedContent>
            <BoxedContent title="KUSK">
              {stats.driver && stats.driver.last_year ? (
                <Driver stats={stats.driver} betType={betType} />
              ) : (
                <Text color="text.tertiary">Statistik saknas</Text>
              )}
            </BoxedContent>
            <BoxedContent title="TRÄNARE">
              {stats.trainer && stats.trainer.last_year ? (
                <Trainer stats={stats.trainer} betType={betType} />
              ) : (
                <Text color="text.tertiary">Statistik saknas</Text>
              )}
            </BoxedContent>
          </FlexBox>
        )}
      />
    </Box>
  </FlexBox>
);

Expanded.propTypes = {
  start: PropTypes.object.isRequired,
  betType: PropTypes.string,
};

export default connect(
  createStructuredSelector({
    access: selectPremium,
  }),
)(Expanded);
